import type {StartupsGlobal} from '~/payload-types'

export function useStartupsMeta() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'startupsGlobal',
      depth: 1,
      draft: !!route.query.preview,
    })
    return result as StartupsGlobal
  }

  return {fetch}
}
